/**
 * 跳转
 * mixin
 */
import { Component, Vue } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'
declare module 'vue/types/vue' {
  interface Vue {
    $jump(to: any): void
    $replace(to: any): void
    // $open(to: string, query?: object, win?: any): void
    $href(to: any): void
  }
}
/**
 * @class Jump
 * @extends {Vue}
 */
@Component({})
export default class Jump extends Vue {
  // 路由跳转
  public $jump(to: RouteConfig) {
    if (this.$router) {
      this.$router.push(to)
    }
  }
  // 路由跳转 无历史记录
  public $replace(to: RouteConfig) {
    if (this.$router) {
      this.$router.replace(to)
    }
  }
  // 新标签 to为路由地址，query为url传参，win为在请求前创建的window.open()防止浏览器拦截

  // 废弃 open ==> href
  // public $open(to: string, query?: object, win?: any) {
  //   // '/ps/partners/wish/authorize.htm'
  //   const local = window.location
  //   const origin = local.origin
  //   let url = origin + to

  //   url = query ? url + '?' + query : url
  //   win ? (win.location.href = url) : window.open(url)
  // }
  /**
   * location 浏览器跳转
   *  @param  options Object 配置(已解构)
   *  @param  origin String 目标url的origin
   *  @param  hash String 目标url的hash
   *  @param  query Object 目标url的query
   *  @param  open Boolean 是否打开新窗口
   *  @param  win win 请求前创建的window对象，防止浏览器拦截
   */
  public $href(params: any) {
    const {
      fullPath,
      origin,
      hash = '',
      query = {},
      open = false,
      win
    } = params
    const searchQuery = Object.keys(query)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
      .join('&')
    // query对象转url查询参数
    const search = searchQuery ? '?' + searchQuery : ''

    // url
    const url = fullPath || origin + hash + search
    // win为在请求前创建的window.open()防止浏览器拦截，使用win跳转
    if (win) {
      win.location.href = url
      return
    }
    // 跳转
    open ? window.open(url) : (window.location.href = url)
  }
}
